import type { StoreTotals } from './types';
import { t } from '../lib/i18n';

const DAEMON_TIMEOUT_MS = 30_000;

async function fetchJSON<T>(url: string, opts: { timeoutMs?: number; daemon?: boolean } = {}): Promise<T> {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), opts.timeoutMs ?? 8_000);
  try {
    const res = await fetch(url, { credentials: 'same-origin', signal: ctl.signal });
    if (!res.ok) {
      if (opts.daemon && (res.status === 502 || res.status === 503)) {
        throw new Error(t.errors.daemonOffline);
      }
      if (res.status === 503) throw new Error('cache not ready');
      throw new Error(`HTTP ${res.status}`);
    }
    return (await res.json()) as T;
  } finally {
    clearTimeout(timer);
  }
}

export function fetchStoreTotals(args: { from: string; to: string }): Promise<StoreTotals> {
  const q = new URLSearchParams({ from: args.from, to: args.to });
  return fetchJSON<StoreTotals>(`/api/store-totals?${q}`, { timeoutMs: DAEMON_TIMEOUT_MS, daemon: true });
}
